// extracted by mini-css-extract-plugin
export default {"Package":"rHZlvTqkaA0T8APKfVI1"};